import React, { useEffect, useMemo, useState } from 'react';
import type { Attachment, AttachmentsIndex, Park } from '../../types';
import { loadAttachmentsIndex, resolveAttachmentsForPark } from '../../utils/parkAttachments';
import { AttachmentPreviewModal } from './AttachmentPreviewModal';

export interface ParkFileAttachmentsProps {
  park: Park;
  /**
   * 国家级：始终渲染「文件」一行；无附件时显示 —。其它类型无附件时不渲染该行。
   */
  alwaysShowFileRow?: boolean;
}

export function ParkFileAttachments(props: ParkFileAttachmentsProps): React.ReactElement | null {
  const { park, alwaysShowFileRow } = props;
  const [preview, setPreview] = useState<Attachment | null>(null);
  const [index, setIndex] = useState<AttachmentsIndex | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    loadAttachmentsIndex().then((idx) => {
      if (!cancelled) setIndex(idx);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const attachments = useMemo(() => {
    if (index === undefined) return [];
    return resolveAttachmentsForPark(park, index);
  }, [park, index]);

  if (!alwaysShowFileRow) {
    if (index === undefined || attachments.length === 0) return null;
    return (
      <>
        <div className="dash-detail-row dash-detail-row--attachments">
          <div className="dash-detail-row__label">文件</div>
          <div className="dash-detail-row__value">
            <ul className="dash-attachment-list">
              {attachments.map((a) => (
                <li key={a.path}>
                  <button
                    type="button"
                    className="dash-attachment-link"
                    onClick={() => setPreview(a)}
                  >
                    {a.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <AttachmentPreviewModal
          open={preview !== null}
          attachment={preview}
          onClose={() => setPreview(null)}
        />
      </>
    );
  }

  const valueContent =
    index === undefined ? (
      '—'
    ) : attachments.length === 0 ? (
      '—'
    ) : (
      <ul className="dash-attachment-list">
        {attachments.map((a) => (
          <li key={a.path}>
            <button
              type="button"
              className="dash-attachment-link"
              onClick={() => setPreview(a)}
            >
              {a.label}
            </button>
          </li>
        ))}
      </ul>
    );

  return (
    <>
      <div className="dash-detail-row dash-detail-row--attachments">
        <div className="dash-detail-row__label">文件</div>
        <div className="dash-detail-row__value">{valueContent}</div>
      </div>
      <AttachmentPreviewModal
        open={preview !== null}
        attachment={preview}
        onClose={() => setPreview(null)}
      />
    </>
  );
}
